import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBooks"><Path d="M18.3467 6.33496L14 7.49965L17.4941 20.5396L21.8407 19.375L18.3467 6.33496Z" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 3.5H13.5V20.5H7.50002L7.5 3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M7.49998 5.5H2.5V20.5H7.5" stroke="currentColor" strokeLinecap="round"/><Path d="M7.5 7.5H13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 16.5H13.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBooks;
